import type { SVGProps } from 'react';

export default function LtaLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 220 133" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M220 0 199 101 162 33h-2l-26 48v2h17l10-19h1l32 58-2 11L0 82v-3l55-65L220 0ZM57 35h16v35h14l8 13H57V35Zm35-1h52l-8 14h-12v35h-16V48H92V34Z"
      />
    </svg>
  );
}
